import(/* webpackMode: "eager", webpackExports: ["ExternalScripts"] */ "/builds/atbdigitalteam/growlabs/software/grow-frontend/origination/src/app/external.tsx");
;
import(/* webpackMode: "eager" */ "/builds/atbdigitalteam/growlabs/software/grow-frontend/origination/src/index.scss");
;
import(/* webpackMode: "eager" */ "/builds/atbdigitalteam/growlabs/software/grow-frontend/origination/src/resources/fonts.css");
